import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES } from "../lib/data";

const Servizi = () => {
  const handleQuote = (pack) => {
    const el = document.getElementById("contatti");
    if (el) {
      const sel = document.querySelector('select[name="event_type"]');
      el.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        if (sel) sel.value = pack;
      }, 600);
    }
  };

  return (
    <section
      id="servizi"
      className="relative py-28 md:py-40 bg-[var(--pw-surface)] overflow-hidden"
      data-testid="servizi-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-20">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-line" />
              <span className="overline">Pacchetti</span>
            </div>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--pw-text)] max-w-3xl">
              Tre <em className="text-[var(--pw-gold)]">soluzioni</em>,<br />
              un solo livello: l'eccellenza.
            </h2>
          </div>
          <p className="text-[var(--pw-text)]/65 font-light max-w-md text-base md:text-lg">
            Ogni pacchetto è un punto di partenza. Componiamo insieme la giornata
            ideale, scegliendo formazione, repertorio e momenti chiave.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.code}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className={`card-pw p-8 lg:p-10 flex flex-col ${
                s.highlight ? "ring-1 ring-[var(--pw-gold)]/40 relative" : ""
              }`}
              data-testid={`service-card-${s.code}`}
            >
              {s.highlight && (
                <div className="absolute -top-3 left-8 px-3 py-1 bg-[var(--pw-gold)] text-black text-[10px] uppercase tracking-[0.28em]">
                  Più richiesto
                </div>
              )}
              <div className="font-serif italic text-[var(--pw-gold)] text-lg">
                — {s.code}
              </div>
              <h3 className="mt-4 font-serif font-light text-3xl md:text-4xl text-[var(--pw-text)] leading-tight">
                {s.name}
              </h3>
              <div className="mt-3 text-[var(--pw-gold)] text-sm uppercase tracking-[0.22em]">
                {s.price}
              </div>
              <p className="mt-6 text-[var(--pw-text)]/70 font-light text-[15px] leading-relaxed">
                {s.desc}
              </p>

              <ul className="mt-8 space-y-3 flex-1">
                {s.features.map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-3 text-sm text-[var(--pw-text)]/80 font-light"
                  >
                    <Check size={16} className="text-[var(--pw-gold)] shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => handleQuote(s.name)}
                className="btn-pw mt-10 w-full justify-center"
                data-testid={`service-cta-${s.code}`}
              >
                Richiedi questo pacchetto
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servizi;
